module.exports = __webpack_public_path__ + "static/media/parking_siren.1414071c.svg";